import React from 'react';
import { motion } from 'framer-motion';

// Animation
const top = {
  initial: {
    rotate: 0,
    translateY: 0,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  animate: {
    rotate: 25,
    translateY: 8,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
};

const middle = {
  initial: {
    opacity: 1,
  },
  animate: {
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
};

const bottom = {
  initial: {
    rotate: 0,
    translateY: 0,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  animate: {
    rotate: -25,
    translateY: -8,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
};

export const MenuToggle = ({ className, navOpen, white, ...props }) => {
  const variant = navOpen ? 'animate' : 'initial';
  return (
    <button {...props} className={`${className} outline-remove`}>
      <svg viewBox='0 0 39 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <motion.rect
          variants={top}
          initial='initial'
          animate={variant}
          x='0.100006'
          y='1'
          width='38.8'
          height='2'
          fill={white ? 'white' : 'black'}
        />
        <motion.rect
          variants={middle}
          initial='initial'
          animate={variant}
          x='0.100006'
          y='9'
          width='38.8'
          height='2'
          fill={white ? 'white' : 'black'}
        />
        <motion.rect
          variants={bottom}
          initial='initial'
          animate={variant}
          x='0.100006'
          y='17'
          width='38.8'
          height='2'
          fill={white ? 'white' : 'black'}
        />
      </svg>
    </button>
  );
};
